import React, { useState } from "react"
import MetaTags from "react-meta-tags"

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Label,
  Input,
  Container,
  CustomInput,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import Select from "react-select"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

export default function AddLastMinuteeDeal() {

  const [selectedGroup, setselectedGroup] = useState(null)

  function handleSelectGroup(selectedGroup) {
    setselectedGroup(selectedGroup)
  }

  const optionGroup = [
    {
      label: "Picnic",
      options: [{ label: "Fresho Farm Eggs", value: "Fresho Farm Eggs" }],
    },
  ]
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Add Last Minute Deal | Virtual Supermarket</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Add Last Minute Deal" />
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Row>

                      <Col lg="4">
                        <div className="mb-3">
                          <Label>Select Product</Label>
                          <Select
                            value={selectedGroup}
                            onChange={() => {
                              handleSelectGroup()
                            }}
                            options={optionGroup}
                            classNamePrefix="select2-selection"
                          />
                        </div>
                      </Col>

                      <Col lg="4">
                        <div className="mb-3">
                          <Label>Product Pack Size</Label>
                          <Input
                            type="select"
                            id="Country"
                            name="Country"
                            className="form-select"
                          >
                            <option value="0">
                              ---&nbsp; Please Select Product Pack Size &nbsp;---
                            </option>
                            <option value="1">kg</option>
                            <option value="2">ml</option>
                            <option value="3">gm</option>
                          </Input>
                        </div>
                      </Col>

                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="Price">Price</Label>
                          <AvField
                            name="Price"
                            placeholder="Price"
                            type="text"
                            className="form-control"
                            id="Price"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="3    ">
                        <FormGroup className="mb-3">
                          <Label htmlFor="Discount">Discount %</Label>
                          <AvField
                            name="Discount"
                            placeholder="Discount"
                            type="text"
                            className="form-control"
                            id="Discount"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="3">
                        <FormGroup className="mb-3">
                          <Label htmlFor="UpdatedPrice">Updated Price</Label>
                          <AvField
                            name="UpdatedPrice"
                            placeholder="Updated Price"
                            type="text"
                            className="form-control"
                            id="UpdatedPrice"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="3">
                        <FormGroup className="mb-3">
                          <Label htmlFor="StartDate">Start Time</Label>
                          <AvField
                            name="StartTime"
                            placeholder="Start Time"
                            type="time"
                            className="form-control"
                            id="StartDate"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="3">
                        <FormGroup className="mb-3">
                          <Label htmlFor="EndTime">End Time</Label>
                          <AvField
                            name="EndTime"
                            placeholder="End Time"
                            type="time"
                            className="form-control"
                            id="EndTime"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label className="mb-3" htmlFor="AssignRole">
                            Active/Deactive *
                          </Label>
                          <br />
                          <Input
                            type="radio"
                            className="form-check-input"
                            id="Active"
                            name="aandd"
                          />
                          &nbsp;
                          <Label className="form-check-label" htmlFor="Active">
                            {" "}
                            Active
                          </Label>
                          &nbsp;&nbsp;&nbsp;
                          <Input
                            type="radio"
                            className="form-check-input"
                            id="Deactive"
                            name="aandd"
                          />
                          &nbsp;
                          <Label className="form-check-label" htmlFor="Deactive">
                            {" "}
                            Deactive
                          </Label>
                          
                        </FormGroup>
                      </Col>
                    </Row>
                    
                    <Button color="primary" type="submit">
                      Submit form
                    </Button>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
